import React from "react";
import Lottie from "react-lottie";
import {animationData} from "../../assets";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const { t } = useTranslation();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="w-full relative   flex-col flex items-center justify-center">
      <Lottie options={defaultOptions} width={150} height={150} />

      <h1 className=" text-center body-1 text-color-3">
        {t("Loading ...")}
      </h1>
    </div>
  );
};

export default Loader;
